<ng-container *ngIf="!isDataModified; then spinnerTemplate else mainTemplate"></ng-container>

<ng-template #spinnerTemplate></ng-template>

<ng-template #mainTemplate>
  <div #wrapperElement class="frame-wrapper" [ngStyle]="frameBasiStyles">
    <div (wheel)="onMouseWheel($event)" class="frame-wrapper__device h-100 w-100">
  
        <!-- image background -->
        <img *ngIf="mediaData.is_background_image" class="frame-wrapper__image h-100 w-100" [src]="mediaData.background_url" alt="background_url">
        <!-- video background -->
        <video *ngIf="!mediaData.is_background_image" id="videoPlayer" class="frame-wrapper__video" width="100%" height="100%" [muted]="true" loop autoplay playsinline>
          <source [src]="mediaData.background_url" type="video/mp4">
        </video>
  
        <div class="frame-wrapper__device-bgDefault" [ngClass]="{'frame-wrapper__device-bglightdarker': (isShowProfile || isShowModalCardInfo), 'frame-wrapper__device-bgdarker': isShowFeatureContent}"></div>
  
      <div #headerTopElement *ngIf="!isShowModalCardInfo" class="frame-wrapper__topper" [style.display]="!isHideAllContain ? 'block' : 'none'">
        <span *ngIf="isShowBackButton || isShowModalCardInfo">
          <img (click)="backToContainerIcons()" class="frame-wrapper__topper-plus frame-wrapper__topper-clickable mr-4" [src]="weblinkIcons.back" width="20" height="20" alt="mute">
        </span>
        <span class="frame-wrapper__topper-mobile" *ngIf="!mediaData?.is_private">
          <img (click)="getVCard()" [src]="weblinkIcons.plus_white" class="frame-wrapper__topper-clickable" width="20" height="20" alt="mute">
          <span (click)="getVCard()" class="frame-wrapper__topper-text-left frame-wrapper__topper-clickable ml-1">Add to phonebook</span>
        </span>
        <span class="frame-wrapper__topper-mobile" *ngIf="mediaData?.is_private">
          <img (click)="showPrivateModal()" [src]="weblinkIcons.plus_white" class="frame-wrapper__topper-clickable" width="20" height="20" alt="mute">
          <span (click)="showPrivateModal()" class="frame-wrapper__topper-text-left frame-wrapper__topper-clickable ml-1">Add to phonebook</span>
        </span>
        <span class="frame-wrapper__topper-mobile float-right">
          <span class="frame-wrapper__topper-text-right frame-wrapper__topper-clickable mr-1">Connect</span>
          <img class="ml-1" [src]="weblinkIcons.connect_green" class="frame-wrapper__topper-clickable" width="20" height="20" alt="mute">
        </span>
      </div>
      <div #logoElement *ngIf="!isShowModalCardInfo" class="frame-wrapper__logo" [ngClass]="{'frame-wrapper__logo-mt': !isShowModalCardInfo}"
        [style.display]="(!isHideAllContain && mediaData?.type !== 'WC') ? 'block' : 'none'">
        <span>
          <img *ngIf="cardIcon" (click)="openCardInfo()" [src]="cardIcon" [ngClass]="{'frame-wrapper__topper-clickable': isShowProfileInfo}" alt="company-logo">
        </span>
      </div>
  
      <!-- company info -->
      <app-weblink-frame-company-info *ngIf="isShowModalCardInfo" [mediaData]="mediaData" (setModalDisplay)="getModalDisplay($event)"></app-weblink-frame-company-info>
  
      <div (click)="mediaTrigger()" class="frame-wrapper__container"
        [ngClass]="isWindowInnerHeightGreater800 ? 'frame-wrapper__container-bigscreen' : 'frame-wrapper__container-smallscreen' ">
        <!-- profile -->
        <div class="frame-wrapper__container-profile" *ngIf="!isHideAllContain && !isShowModalCardInfo"
          [ngClass]="{'frame-wrapper__container-profile-totop': isShowAllActions, 'frame-wrapper__zindex0': isShowAllActions, 'frame-wrapper__container-profile-tobottom': !isShowAllActions, 'frame-wrapper__container-profile-tobottomfix': iconLogoToBottom, 'frame-wrapper__container-profile-totopdefault': iconLogoToDefault}">
          <!-- not WC -->
          <span *ngIf="mediaData?.type !== 'WC'" class="frame-wrapper__container-profile-image"
            [ngClass]="isShowAllActions ? 'frame-wrapper__container-profile-image-totop' : 'frame-wrapper__container-profile-image-tobottom'">
            <img *ngIf="cardLogo" (click)="allActions()" class="mb-3 frame-wrapper__topper-clickable" [src]="cardLogo" alt="company-logo"
              [ngClass]="{'frame-wrapper__container-profile-unclick': iconLogoToBottom}">
          </span>
          <!-- WC -->
          <span *ngIf="mediaData?.type === 'WC'" class="frame-wrapper__container-profile-image-wc"
            [ngClass]="isShowAllActions ? 'ulala-totop-wc' : 'ulala-tobottom-wc'">
            <img (click)="allActions()" class="mb-3 frame-wrapper__topper-clickable" [src]="mediaData?.icon" alt="company-logo"
              [ngClass]="{'frame-wrapper__container-profile-unclick': iconLogoToBottom}">
          </span>
  
          <div class="frame-wrapper__container-profile-text">
            <div class="frame-wrapper__container-profile-name">{{mediaData?.name}}</div>
            <div class="frame-wrapper__container-profile-description"> {{mediaData?.description}} </div>
          </div>
        </div>
  
        <!-- icons action -->
        <div *ngIf="isShowAllActions && iconsAnimation" class="frame-wrapper__container-icon">
          <app-frame-icons [mediaData]="mediaData" (iconActionSender)="listenIconAction($event)" [currentStep]="currentStep" [barColor]="barColor"></app-frame-icons>
        </div>
  
        <!-- gradient -->
        <div class="frame-wrapper__container-gradient"
          *ngIf="(isShowAllActions || isShowActionTextIcons || isShowActionSocialLinkIcons) && (!isShowProfile && !isShowFeatureContent) && iconsAnimation"
          [ngClass]="{'frame-wrapper__container-gradient-b0': (isShowActionTextIcons || isShowActionSocialLinkIcons)}"></div>
        <!-- touch screen go back from 3rd screen to 2nd screen -->
        <div *ngIf="isShowAllActions && (isShowActionTextIcons || isShowActionSocialLinkIcons)" (click)="backToContainerIcons()" class="frame-wrapper__container-screen 3"></div>
        <!-- touch screen go back from 2nd screen to main screen -->
        <div *ngIf="isShowAllActions && !isShowActionTextIcons && !isShowActionSocialLinkIcons" (click)="gotoMainScreen()" class="frame-wrapper__container-screen 2" [style.z-index]="4"></div>
        <!-- arrow up -->
        <!-- <div class="frame-wrapper__container-arrow-up" *ngIf="!isShowAllActions && !isShowModalCardInfo">
          <img (click)="allActions()" [src]="weblinkIcons.arrow_up" alt="arrow-up" width="21" height="21">
        </div> -->
      </div>
  
      <!-- feature wrapper -->
      <div class="frame-wrapper__feature" *ngIf="isHideAllContain && isShowFeatureContent">
        <app-frame-feature [mediaData]="mediaData" [fullPreview]="fullPreview" (goBackToMainIcons)="listenOnGoBack($event)"></app-frame-feature>
      </div>
  
      <!-- profile wrapper -->
      <div class="frame-wrapper__profile" *ngIf="isHideAllContain && isShowProfile">
        <app-frame-profile [mediaData]="mediaData" (goBackToMainIcons)="listenOnGoBack($event)"></app-frame-profile>
      </div>
  
    </div>
  </div>
</ng-template>